import React, { FC, ReactElement, useState } from 'react'
import { Typography, Button, Modal, Space } from 'antd'
import { CopyOutlined, ExclamationCircleOutlined } from '@ant-design/icons'

import s from './styles.module.scss'

interface ConfirmDuplicateRonProps {
  duplicatePath: string
  variant: 'admin' | 'client'
}

const ConfirmDuplicateRon: FC<ConfirmDuplicateRonProps> = ({ duplicatePath, variant }): ReactElement => {
  const [visible, setVisible] = useState(false)

  const handleOk = () => {
    window.location.href = duplicatePath
  }

  const handleCancel = () => {
    setVisible(false)
  }

  const trigger =
    variant === 'admin' ? (
      <Button type="link" icon={<CopyOutlined />} onClick={() => setVisible(true)}>
        Duplicate
      </Button>
    ) : (
      <Button icon={<CopyOutlined />} onClick={() => setVisible(true)} block>
        Duplicate this order
      </Button>
    )

  return (
    <>
      {trigger}
      <Modal visible={visible} width={400} title={null} closable={false} footer={null} bodyStyle={{ padding: 24 }}>
        <Space align="start" size={12}>
          <ExclamationCircleOutlined className={s.warningIcon} />
          <Space direction="vertical" size={0}>
            <Typography.Title level={5} className="mtn">
              Won&apos;t create new RON transaction
            </Typography.Title>
            <Typography.Paragraph>
              Duplicating this order will not create a new transaction in Snapdocs RON. If you want to do that, you must
              create a new order.
            </Typography.Paragraph>
            <div className={s.footer}>
              <Button onClick={handleCancel}>Cancel</Button>
              <Button type="primary" onClick={handleOk}>
                Duplicate anyway
              </Button>
            </div>
          </Space>
        </Space>
      </Modal>
    </>
  )
}

export default ConfirmDuplicateRon
